/**
 * Whether a keyboard event belongs to the game or to something being typed in.
 *
 * ⚠️ **Every key handler in the client listens on `document`.** Movement, the
 * flat-view toggle, the render-distance keys — all of them. That was fine
 * while the only interactive elements were two buttons, and it stops being
 * fine the moment there is a text box: typing "Urðarstígur" into the Dev Tools
 * search would walk the player (W, A, S, D), toggle flying (F), reset the zoom
 * (R) and flatten the world (G), all while the letters appear in the box.
 *
 * So every `document`-level game key handler asks this first.
 */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;

  const tag = target.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;

  /* Anything the browser has been told is editable — no such element exists
     today, but the check costs nothing and its absence is a subtle bug. */
  return target.isContentEditable;
}
